export const DAYS_DOMAIN = 'days'

export const DAYS_KEY = {
  ALL: 'all',
  DATA: 'data',
  BY_DATE: 'byDate',
  CURRENT: 'current'
}

export const DAYS_PATH = {
  ALL: `${DAYS_DOMAIN}.${DAYS_KEY.ALL}`,
  ALL_DATA: `${DAYS_DOMAIN}.${DAYS_KEY.ALL}.data`,
  DATA: `${DAYS_DOMAIN}.${DAYS_KEY.DATA}`,
  BY_DATE: `${DAYS_DOMAIN}.${DAYS_KEY.BY_DATE}`,
  CURRENT: `${DAYS_DOMAIN}.${DAYS_KEY.CURRENT}`
}

export const DAYS_STATE = {
  [DAYS_KEY.ALL]: {
    data: [],
    status: null
  },
  [DAYS_KEY.CURRENT]: null,
  [DAYS_KEY.DATA]: {},
  [DAYS_KEY.BY_DATE]: {}
}

export const DAYS_ANALYTICS_EVENT = {
  CREATED: 'Day Created',
  CLOSED: 'Day Closed',
  LINK_PRESSED: 'Day Link Pressed',
  MARK_AS_READ: 'Days Mark As Read',
  REPLY_ADDED: 'Day Reply Added',
  DELETED: 'Day Deleted'
}

export const DAYS_ACTION = {
  CREATE: 'DAYS_CREATE',
  CLOSE: 'DAYS_CLOSE',
  ADD_REPLY: 'DAYS_ADD_REPLY',
  LOAD: 'DAYS_LOAD',
  LOAD_BY_ID: 'DAYS_LOAD_BY_ID',
  SAVE: 'DAYS_SAVE',
  UPDATE_CURRENT: 'DAYS_UPDATE_CURRENT',
  MARK_AS_READ: 'DAYS_MARK_AS_READ',
  UPDATE_MESSAGE: 'DAYS_UPDATE_MESSAGE',
  UPDATE_READ_AT: 'DAYS_UPDATE_READ_AT',
  DELETE_CURRENT: 'DAYS_DELETE_CURRENT',
  UPDATE: 'DAYS_UPDATE',
  DELETE: 'DAYS_DELETE'
}

const ROOT = '/days'
export const DAYS_ENDPOINT = {
  ROOT,
  MARK_AS_READ: `${ROOT}/mark-as-read`
}
